export default {"src":"/_next/static/media/ge.fec2903a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};